import Vue from 'vue'
import Router from 'vue-router'
import laout from '@/views/laout/laout'
import laoutManage from '@/views/laout/laoutManage'
import laoutIndex from '@/views/laout/laoutIndex'

Vue.use(Router)


export const routes = [
{ path: '/404',hidden:true, component: () => import('@/views/404') },
{
  path: '/login',
  component: ()=>import('@/views/login/login'),
  hidden:true,
},
  { path: '/regvip', component: () => import('@/views/login/reg_vip'), hidden: true },
{
  path: '/',
  component: laoutIndex,
  hidden:true,
  meta: { title: '设计小程序', icon: 'block' }
},
{
  path: '/blocks',
  component: laout,
  redirect:'/blocks/index',hidden:true,
  meta: { title: '设计小程序', icon: 'block' },
  children:[{
    path:'/blocks/index/:page',
    name:'blocks',
    component:  ()=>import('@/views/blocks/blocks')
  }]
},

{
  path: '/manage',
  component: laoutManage,
  redirect:'/manage/index',
  meta: { title: '设置中心', icon: 'a_setting' },
  children:[{
    path:'/manage/index',
    meta: { title: '授权配置' },
    component:  ()=>import('@/views/setting/index')
  },{
    path:'/manage/store_setting',
    meta: { title: '商家设置' },
    component:  ()=>import('@/views/setting/store_setting')
  },{
    path:'/manage/share',
    meta: { title: '分享设置' },
    component:  ()=>import('@/views/setting/share')
  }
  ]
},
{
  path: '/order',
  component: laoutManage,
  redirect:'/order/order',
  meta: { title: '订单中心', icon: 'a_article' },
  children:[
    {
    path:'/order/order',
    meta: { title: '管理订单' },
    component:  ()=>import('@/views/goods/order')
  },{
    path:'/order/inform',
    meta: { title: '订单通知' },
    component:  ()=>import('@/views/goods/inform')
  },
]
},
{
  path: '/goods',
  component: laoutManage,
  redirect:'/goods/list',
  meta: { title: '商城管理', icon: 'a_store' },
  children:[
  {
    path:'/goods/classify',
    meta: { title: '商品分类' },
    component:  ()=>import('@/views/goods/classify')
  },
  {
    path:'/goods/list',
    meta: { title: '商品列表' },
    component:  ()=>import('@/views/goods/list')
  },
  {
    path:'/goods/express',
    meta: { title: '运费设置' },
    component:  ()=>import('@/views/goods/express')
  },
  ]
},
{
  path: '/market',
  component: laoutManage,
  redirect:'/market/index',
  meta: { title: '商城营销', icon: 'a_market' },
  children:[
  {
    path:'/market/index',
    meta: { title: '营销中心' },
    component:  ()=>import('@/views/market/market')
  },
  {
    path:'/market/ticket',
    meta: { title: '优惠券',hidden:true },
    component:  ()=>import('@/views/market/ticket')
  },
  {
    path:'/market/groupbuy',
    meta: { title: '商品拼团',hidden:true },
    component:  ()=>import('@/views/market/groupbuy')
  },
  {
    path:'/market/topup',
    meta: { title: '充值',hidden:true },
    component:  ()=>import('@/views/market/topup')
  },
  {
    path:'/market/distribution',
    meta: { title: '分销中心',hidden:true },
    component:  ()=>import('@/views/market/distribution')
  },
  {
    path:'/market/score',
    meta: { title: '积分设置',hidden:true },
    component:  ()=>import('@/views/market/score')
  }
  ]
},
{
  path: '/video',
  component: laoutManage,
  redirect:'/video/video',
  meta: { title: '视频课程', icon: 'a_article' },
  children:[{
    path:'/video/video',
    meta: { title: '管理课程' },
    component:  ()=>import('@/views/video/video')
  },{
    path:'/video/classify',
    meta: { title: '管理分类' },
    component:  ()=>import('@/views/video/classify')
  }
  ]
},
{
  path: '/article',
  component: laoutManage,
  redirect:'/article/article',
  meta: { title: '文章管理', icon: 'a_article' },
  children:[{
    path:'/article/article',
    meta: { title: '管理文章' },
    component:  ()=>import('@/views/article/article')
  },{
    path:'/article/classify',
    meta: { title: '管理分类' },
    component:  ()=>import('@/views/article/classify')
  }]
},
{
  path: '/sever',
  component: laoutManage,
  redirect:'/sever/sever',
  meta: { title: '服务预约', icon: 'a_service' },
  children:[{
    path:'/sever/sever',
    meta: { title: '服务列表' },
    component:  ()=>import('@/views/sever/sever')
  },{
    path:'/sever/classify',
    meta: { title: '服务分类' },
    component:  ()=>import('@/views/sever/classify')
  }]
},

{
  path: '/idcard',
  component: laoutManage,
  redirect:'/idcard/idcard',
  meta: { title: '名片管理', icon: 'a_card' },
  children:[{
    path:'/idcard/idcard',
    meta: { title: '智能名片' },
    component:  ()=>import('@/views/idcard/idcard')
  },]
},

{
  path: '/form',
  component: laoutManage,
  redirect:'/form/form',
  meta: { title: '表单管理', icon: 'a_form' },
  children:[{
    path:'/form/form',
    meta: { title: '表单管理' },
    component:  ()=>import('@/views/form/form')
  },{
    path:'/form/formContent',
    meta: { title: '已提交的表单' },
    component:  ()=>import('@/views/form/formContent')
  }]
},
{
  path: '/user',
  component: laoutManage,
  redirect:'/user/user',
  meta: { title: '用户列表', icon: 'a_card' },
  children:[{
    path:'/user/user',
    meta: { title: '用户列表' },
    component:  ()=>import('@/views/user/list')
  },]
},

  {
    path: '/assist',
    component: laoutManage,
    redirect: '/assist/customer',
    meta: { title: '辅助功能', icon: 'assist' },
    children: [
      {
        path: '/assist/customer',
        component: () => import('@/views/assist/customer'),
        meta: { title: '客服人员' }
      }
    ]
  },
{ path: '*',hidden:true, redirect: '/404'},
// { path: '/',hidden:true, redirect: '/manage'}
]

export default new Router({
  routes: routes
})



// WEBPACK FOOTER //
// ./src/router/index.js